import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  cuedmontonLink = "";
  lang="";
  constructor() { }

  ngOnInit(): void {
    console.log('ss');
    this.cuedmontonLink = "https://cuedmonton.robogarden.ca/";
    this.lang = localStorage.getItem('language') || 'en';
  }
  currentYear = new Date().getFullYear();
}
